module.exports = __webpack_public_path__ + "img/cloud2.4077f607.png";